
import React, { Fragment } from "react";
import back from "../assets/arrow.svg";
 

function Header({ handleClose, isSubmitted }) {
  return (
    <Fragment>
      {!isSubmitted && (
        <>
          <div className="image-wrapper" onClick={handleClose}>
            <img src={back} alt="back" />
            <div className="Backheading">Back to Landing Page</div>
          </div>
          <div className="header-wrapper">
            <div className="row d-flex justify-content-center w-100">
              <div className="col-md-8">
                <h3>Request for NICDSign </h3>
               
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
}

export default Header;